import { render, staticRenderFns } from "./PersonalForm.vue?vue&type=template&id=59bbefe2"
import script from "./PersonalForm.vue?vue&type=script&lang=js"
export * from "./PersonalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports